import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { Injector } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { Component, OnInit } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

interface IHandbookImportTab {
    Sref: string;
    Title: string;
}

@Component({
    selector: 'fi-handbook-import',
    template: `
        <div class="fi-container">
            <div class="fi-header">
                <fi-tabs
                    [tabsModel]="tabs"
                    [selectedIndex]="selectedIndex"
                    (selectedIndexChange)="onTabIndexChange($event)"
                ></fi-tabs>
            </div>
            <div class="fi-content">
                <ui-view></ui-view>
            </div>
        </div>
    `,
    styleUrls: ['./handbook-import.component.scss'],
    standalone: false,
})
export class FiHandbookImportComponent extends TabsModuleBase implements OnInit {
    tabs: IHandbookImportTab[];

    constructor(
        injector: Injector,
        private appTextService: AppTextService,
        private userDataService: FiUserDataService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.tabs = [
            {
                Sref: FiStateNames.Import.Handbook.Word,
                Title: this.appTextService.get('import.word'),
            },
            // {
            // Sref: FiStateNames.Import.Handbook.MindMap,
            // Title: this.appTextService.get('import.mind_manager')
            // }
        ];

        if (this.userDataService.canLoginSupportSession()) {
            this.tabs.push({
                Sref: FiStateNames.Import.Handbook.WordExport,
                Title: this.appTextService.get('import.word_export'),
            });
        }
        super.updateSelectedTabFromState();
    }
}
